import { DependencyList, useEffect, useRef } from 'react';

/***
 * demo:
 * function() {
 *    const [state, setState] = useState();
 *    const stateToNextTick = useNextTick([state]);
 *    xhr.then((data) => {
 *        stateToNextTick.nextTick(() => {
 *            // nextTick event
 *        });
 *        setState(data);
 *    })
 * }
 */
export function useNextTick(deps: DependencyList) {
    const callbackRef = useRef<Function>();

    useEffect(() => {
        if (callbackRef.current) {
            const func = callbackRef.current;
            callbackRef.current = null;
            Promise.resolve().then(() => {
                func();
            });
        }
    }, deps);

    return {
        nextTick(callback) {
            callbackRef.current = callback;
        },
    };
}
